import { api, ReactQueryOptions } from '@api'
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate'
import { useShowToast } from '@hooks/useShowToast'

type optionsType = ReactQueryOptions['SocialManager']['follow']

export const useFollow = (options?: optionsType) => {
    const { showToast } = useShowToast()
    const { updateFollowData } = useInvalidate()
    const utils = api.useContext()

    return api.SocialManager.follow.useMutation({
        mutationKey: ['SocialManager.follow'],
        onError: () => {
            showToast({
                variant: 'error',
                text: 'error.default',
            })
        },
        onSuccess: (data, variables) => {
            if (data.status === 'success') {
                updateFollowData({ shortId: variables.shortid })
                const profile = utils.UserManager.getProfile.getData()
                const shortId = profile?.shortid
                if (typeof shortId === 'string') { updateFollowData({ shortId }) }
            }
        },
        ...options,
    })
}
